import { useState, useEffect } from 'react'
import EasyCrop from 'components/EasyCrop'
import { updateForm } from 'services/licenses'

const Header = ({ fed }) => {
  const {
    name,
    surname,
    points,
    club,
    ranking,
    license,
    photo,
    imageNotApproved
  } = fed.PersonalInformation

  const clubName = fed.Clubs.Clubs.find(({ id }) => id === club) || ''
  const [image, setImage] = useState(null)

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const fileInfo = {
        name: file.name,
        type: file.type,
        size: file.size,
        base64: reader.result.split('base64,').pop(),
        original: URL.createObjectURL(event.target.files[0])
      }
      if (fileInfo.size > 2000000) {
        console.log('Archivo muy grande')
      } else {
        setImage(fileInfo)
      }
    }
  }

  const handleSubmit = async () => {
    if (image) {
      const res = await updateForm({ image1: image }, license)
    }
  }

  useEffect(() => {
    handleSubmit()
  }, [image])

  return (
    <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 bg-blue pt-5 lg:pt-10 pb-16 lg:pl-16 items-center">
      <div className="">
        <div className="text-left pb-6 lg:pb-14">
          <p className="mt-6 text-white text-4xl lg:text-[100px] leading-tight text-center lg:text-left">
            {name}
            <br className="hidden lg:block" />
            <span className="lg:hidden inline"> </span>
            {surname}
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 lg:gap-x-0 max-w-[400px] lg:max-w-[900px]">
          <div className="pt-4 leading-tight">
            <p className="text-accent font-alliance-light text-[18px] lg:text-[30px]">
              Punts:
            </p>
            <p className="text-white font-alliance-medium text-[18px] lg:text-[30px]">
              {points}
            </p>
          </div>
          <div className="pt-4 leading-tight">
            <p className="text-accent font-alliance-light text-[18px] lg:text-[30px]">
              Club:
            </p>
            <p className="text-white font-alliance-medium text-[18px] lg:text-[30px]">
              {clubName?.value}
            </p>
          </div>
          <div className="hidden lg:block"></div>

          <div className="pt-8 leading-tight">
            <p className="text-accent font-alliance-light text-[18px] lg:text-[30px]">
              Rànquing:
            </p>
            <p className="text-white font-alliance-medium text-[18px] lg:text-[30px]">
              {ranking}
            </p>
          </div>
          <div className="pt-8 leading-tight">
            <p className="text-accent font-alliance-light text-[18px] lg:text-[30px]">
              Núm. Llicència:
            </p>
            <p className="text-white font-alliance-medium text-[18px] lg:text-[30px]">
              {license}
            </p>
          </div>
          <div className="hidden lg:block"></div>
        </div>
      </div>
      <div className="lg:grid justify-items-end lg:my-10 lg:mr-16">
        <button className="group relative w-40 h-40 lg:w-[450px] lg:h-[450px] rounded-full overflow-hidden bg-sec-grey-1">
          {photo || image?.blob ? (
            <img
              src={photo || image?.blob}
              className="object-cover w-full h-full"
            />
          ) : (
            <EasyCrop
              image={image?.original}
              imageData={image}
              setImage={setImage}
            />
          )}
          {imageNotApproved && (
            <div className="group-hover:hidden absolute top-0 left-0 w-full h-full flex justify-center items-center">
              <p className="relative z-10 text-blue font-alliance-light text-[18px] lg:text-[30px] mt-4">
                {`En procés d'aprovació`}
              </p>
              <div className="absolute top-0 left-0 w-full h-full bg-white opacity-75"></div>
            </div>
          )}
          <div className="hidden group-hover:flex flex-col absolute top-0 left-0 w-full h-full justify-center items-center">
            <label
              htmlFor="upload"
              className="w-full h-full absolute z-20 cursor-pointer"
            >
              <input
                type="file"
                id="upload"
                className="hidden relative z-20"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.png"
              ></input>
            </label>
            <img
              src="/assets/icons/camera.svg"
              className="relative z-10 w-[62px]"
            />
            <p className="relative z-10 text-blue font-alliance-light text-[18px] lg:text-[30px] mt-4">
              Puja una foto
            </p>
            <div className="absolute w-full h-full bg-white opacity-75"></div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default Header
